import React, { useMemo, useState, useEffect } from 'react';
import { App as AntdApp, ConfigProvider, theme as antdTheme } from 'antd';
import  GeneratorPage from './components/GeneratorPage';
import { initializeFirebase } from './firebase';
import './App.css';

function App() {
  const [isResultVisible, setIsResultVisible] = useState(false);
  const [resultData, setResultData] = useState(null);

  // Initialize Firebase authentication on app start
  useEffect(() => {
    initializeFirebase();
  }, []);

  const tokenOverrides = useMemo(() => ({
    colorPrimary: '#000000',
    colorTextBase: '#000000',
    colorBgBase: '#ffffff',
    borderRadius: 12,
    colorBorder: '#e5e5e5',
    fontSize: 16,
    fontFamily: 'Helvetica, Arial, sans-serif'
  }), []);

  return (
    <ConfigProvider theme={{ algorithm: antdTheme.defaultAlgorithm, token: tokenOverrides }}>
      <AntdApp>
        <div className="app-root">
          <GeneratorPage
            onShowResult={(data) => {
              setResultData(data);
              setIsResultVisible(true);
            }}
            isResultVisible={isResultVisible}
            resultData={resultData}
            onBackToGenerator={() => setIsResultVisible(false)}
          />
        </div>
      </AntdApp>
    </ConfigProvider>
  );
}

export default App;
